import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Frown, Briefcase, Heart, Brain, Battery, HelpCircle, ArrowLeft } from 'lucide-react';

const problems = [
  { id: 'money', label: 'Money stuck', icon: Frown },
  { id: 'career', label: 'Career confusion', icon: Briefcase },
  { id: 'relationship', label: 'Relationship instability', icon: Heart },
  { id: 'mental', label: 'Mental overload', icon: Brain },
  { id: 'energy', label: 'Low energy / motivation', icon: Battery },
  { id: 'other', label: 'Something else', icon: HelpCircle }
];

function ProblemSelection() {
  const [selectedProblem, setSelectedProblem] = useState('');
  const navigate = useNavigate();

  const handleContinue = async () => {
    if (selectedProblem) {
      localStorage.setItem('selectedProblem', selectedProblem);
      
      // Check if profile already exists - if yes, skip data input
      try {
        const response = await axios.get('/api/profile');
        if (response.data.exists) {
          // Profile exists - go directly to analysis
          navigate('/analysis');
        } else {
          // No profile - go to data input
          navigate('/data-input');
        }
      } catch (err) {
        // Error checking - go to data input to be safe
        navigate('/data-input');
      }
    }
  };

  return (
    <div className="page">
      <div className="container" style={{ maxWidth: '800px' }}>
        <button
          onClick={() => navigate('/dashboard')}
          className="btn btn-ghost"
          style={{ marginBottom: '2rem' }}
          data-testid="back-button"
        >
          <ArrowLeft size={20} style={{ marginRight: '0.5rem' }} />
          Back
        </button>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          style={{ textAlign: 'center', marginBottom: '3rem' }}
        >
          <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
            What's bothering you right now?
          </h1>
          <p style={{ fontSize: '1.125rem', color: '#9CA3AF' }}>
            Select the area where you're experiencing challenges
          </p>
        </motion.div>

        <div className="card-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
          {problems.map((problem, index) => (
            <motion.div
              key={problem.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
              className="card"
              onClick={() => setSelectedProblem(problem.id)}
              style={{
                cursor: 'pointer',
                border: selectedProblem === problem.id ? '2px solid #00D9FF' : '1px solid #2D3748',
                background: selectedProblem === problem.id ? 'rgba(0, 217, 255, 0.05)' : '#151827'
              }}
              data-testid={`problem-${problem.id}`}
            >
              <div style={{ textAlign: 'center' }}>
                <problem.icon
                  size={40}
                  color={selectedProblem === problem.id ? '#00D9FF' : '#9CA3AF'}
                  style={{ marginBottom: '1rem' }}
                />
                <p style={{
                  fontSize: '1.125rem',
                  color: selectedProblem === problem.id ? '#00D9FF' : '#F9FAFB'
                }}>
                  {problem.label}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <button
          onClick={handleContinue}
          disabled={!selectedProblem}
          className="btn btn-primary"
          data-testid="continue-button"
          style={{ marginTop: '2rem', maxWidth: '400px', margin: '2rem auto 0', display: 'block', width: '100%' }}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

export default ProblemSelection;